import React from "react";
import "./App.css"; // keep whatever global styles you need
import ShippingPage from "./screens/ShippingPage";

function App() {
  return <ShippingPage />;
}

export default App;
